import { connect } from 'react-redux';
import branch from 'recompose/branch';
import renderComponent from 'recompose/renderComponent';
import compose from 'recompose/compose';

import categoriesAndBrandsProvider from
  '../../../products/hoc/categoriesAndBrandsProvider';
import NoProducts from '../components/NoProducts';
import { getNoProducts } from '../../../products/products/selectors';
import Products from '../components/Products';
import saleProductsProvider from '../hoc/saleProductsProvider';

const ProductsContainer = compose(
  saleProductsProvider,
  categoriesAndBrandsProvider,
  connect(
    state => ({
      noProducts: getNoProducts(state),
    })
  ),
  branch(
    props => props.noProducts,
    renderComponent(NoProducts),
  ),
)(Products);

export default ProductsContainer;
